interface ILoadingIndicatorProps {
    imagePath: string;
}

class LoadingIndicator extends React.Component<ILoadingIndicatorProps, never> {
    public render(): JSX.Element {
        return (
            <div className="loading-component">
                <img src={this.props.imagePath} alt={cacheStore.GetString("LoadingLabel")} />
            </div>
        );
    }
}

export { LoadingIndicator };
